import { PlusCircleIcon } from '@heroicons/react/24/outline'
import classNames from 'classnames'
import React, { useRef, useState } from 'react'
import { useDrop } from 'react-dnd'
import { ManagePartisanChartState } from '../../hooks/use-manage-partisan-chart'
import ManagePartisanChartRaceItem from './manage-partisan-chart-race-item'

const PartisanChartRaces: React.FC<{
  state: ManagePartisanChartState
  handleErrors: React.Dispatch<React.SetStateAction<{}>>
  errors: any
  candidatesNamesChecked: boolean
}> = ({ state, handleErrors, errors, candidatesNamesChecked }) => {
  const {
    addNewRace,
    sortRaces,
    addAllPartisanRaces,
    form: { formState, watch },
    racesFieldArray: { fields: races },
  } = state

  const [showDialog, setShowDialog] = useState(false)
  const [racesName, setRacesName] = useState('')

  const dialogRef = useRef<HTMLDialogElement>(null)

  const watchRaces = watch('races')

  const [, drop] = useDrop(() => ({
    accept: 'CHART-RACE',
    drop: () => ({}),
    collect: () => ({}),
  }))

  return (
    <>
      <div className="container flex items-center gap-4">
        <h2 className="my-8 font-medium tracking-widest uppercase">
          Build Election Test Chart
        </h2>
        <button
          onClick={sortRaces}
          type="button"
          className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          Sort Races
        </button>
      </div>
      <div ref={drop}>
        {watchRaces &&
          races.map((field, index) => (
            <div key={field.id}>
              <ManagePartisanChartRaceItem
                index={index}
                field={field}
                managePartisanChartState={state}
              />
            </div>
          ))}
      </div>
      <div className="flex">
        <button
          onClick={addNewRace}
          type="button"
          className={classNames(
            'border border-primary-blue border-opacity-50 bg-[#E6EBF5] w-full font-semibold py-12 flex justify-center items-center mb-8 mr-2 text-primary-blue rounded-md',
            { 'border-red-500 focus:outline-red-500': formState.errors.races }
          )}
        >
          <PlusCircleIcon className="w-6 mr-2" />
          Add Another Race
        </button>
        <button
          onClick={() => dialogRef.current?.showModal()}
          type="button"
          className={classNames(
            'border border-primary-blue border-opacity-50 bg-[#E6EBF5] w-full font-semibold py-12 flex justify-center items-center mb-8 ml-2 text-primary-blue rounded-md',
            { 'border-red-500 focus:outline-red-500': formState.errors.races }
          )}
        >
          <PlusCircleIcon className="w-6 mr-2" />
          Add Race For All Parties
        </button>
      </div>
      <dialog
        ref={dialogRef}
        aria-modal={true}
        open={showDialog}
        className="fixed inset-0 z-50 rounded-md drop-shadow-md backdrop-blur-lg"
        onClose={() => setShowDialog(false)}
      >
        <h4>Name of Races</h4>
        <input
          value={racesName}
          className="py-3 px-4 bg-[#E6EBF5] rounded-md"
          onChange={(e) => setRacesName(e.target.value)}
        ></input>
        <button
          onClick={() => addAllPartisanRaces(racesName, dialogRef)}
          type="button"
          className="ml-4 uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-white bg-primary-blue text-base font-semibold rounded-md shadow-sm hover:bg-white border hover:text-primary-blue hover:border-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          Submit
        </button>
      </dialog>
    </>
  )
}

export default PartisanChartRaces
